import { BlacklistService } from './blacklistService';

export class BlacklistGuard {
  static async assertUserAllowed(userId?: string | null): Promise<void> {
    if (!userId) return;
    try {
      await BlacklistService.assertUserNotBlacklisted(userId);
    } catch (error) {
      if (error instanceof Error && error.message === 'ACCOUNT_BLACKLISTED') {
        throw new Error('此帳號已被列入黑名單，請聯繫客服進行申訴。');
      }
      throw error;
    }
  }

  static async hasActiveBlacklist(userId?: string | null): Promise<boolean> {
    if (!userId) return false;
    const { entry } = await BlacklistService.getActiveEntryByUser(userId);
    return !!entry;
  }
}




